export const parseReturnUrl = (returnUrl: string): string | undefined => {
  const BASE_URL_REGEX_WITH_PROTOCOL = /^(((http|https):\/\/)((.*\.+)?klarna\.(com|net))|(http:\/\/localhost(:[0-9]+)?))((\/|\?|#).*)?$/;
  const BASE_URL_REGEX = /^((?!((http|https):\/\/))((.*\.+)?klarna\.(com|net))|(localhost(:[0-9]+)?))((\/|\?|#).*)?$/;

  const decodedUrl = decodeURIComponent(returnUrl);

  if (returnUrl) {
    if (BASE_URL_REGEX_WITH_PROTOCOL.test(decodedUrl)) {
      return decodeURIComponent(returnUrl);
    } else if (BASE_URL_REGEX.test(decodedUrl)) {
      const protocol = decodedUrl.startsWith('localhost') ? 'http://' : 'https://';
      return `${protocol}${decodedUrl}`;
    }
  } else {
    return undefined;
  }
};
